import React, { useEffect, useState } from "react";
import { GET } from "../../service/CRUDService";
import FullScreenLoader from "../../common/FullScreenLoader/FullScreenLoader";
import EntityConstants from "../../configs/EntityConstants";
import { useNavigate, useParams } from "react-router-dom";
import VpCategoryCard from "../../components/VpCategoryCard/VpCategoryCard";
import { ReactComponent as BreadcrumbArrowBlackIcon } from "../../resources/icons/breadcrumbArrowBlack.svg";
import { useTranslation } from "react-i18next";

const VpVerificationCheck = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { category_id, category_name } = useParams();
  const [checksList, setChecksList] = useState([]);
  const [isLoadingList, setIsLoadingList] = useState(false);

  const getChecksList = async (id, name) => {
    try {
      setIsLoadingList(true);
      const response = await GET(`${EntityConstants.GET_VP_CHECKS_LIST}${id}`);
      const data = await response.json();
      setChecksList(data?.checks);
    } catch (error) {
      console.log("error while getting category list: ", error);
    } finally {
      setIsLoadingList(false);
    }
  };

  useEffect(() => {
    category_id && category_name && getChecksList(category_id, category_name);
  }, [category_id, category_name]);

  return (
    <div className="flex flex-col items-center w-full pb-3 pt-20 bg-cfSecondary min-h-screen overflow-x-hidden">
      <div
        className="bg-[#F9FAFB] h-16 w-full flex gap-2 items-center px-8"
        id="vp-category"
      >
        {/* <HomeIcon className="w-6 h-6 mb-1" onClick={() => navigate("/")} />
        <BreadcrumbArrowGrayIcon className="w-6 h-6" /> */}
        <p
          id="vp-check-category-breadcrumb-button"
          className="font-semibold text-[#6C788F]  cursor-pointer"
          onClick={() => navigate("/verifier/vp/category")}
        >
          {t("request:select_category")}
        </p>
        <BreadcrumbArrowBlackIcon className="w-6 h-6" />
        <p className="font-semibold text-cfTextBreadcrumbActive">
          {t("request:select_check_type")}
        </p>
      </div>
      <div className="w-full mt-10 sm:mx-8 sm:mt-8 sm:mb-0 flex flex-col items-center sm:items-start px-8">
        <p className="text-xl font-semibold">
          {t("request:select_check_for")}{" "}
          <span className={`lowercase`}>{category_name}</span>
        </p>
      </div>
      <div
        className={`w-full bg-cfSecondary flex justify-center py-[0.8rem] px-8`}
      >
        <div
          className={`flex flex-col lg-xl:flex-row items-start lg-xl:items-center justify-between w-full`}
        >
          {/* <span className="flex items-center gap-2">
              <Dropdown
                options={options}
                selected={
                  options.find((option) => option.value === status) ||
                  options[0]
                }
                onSelect={updateStatus}
                buttonClass="border"
                menuClass="z-20"
              />
            </span> */}
          {/* Search */}
          {/* <form
              onSubmit={(e) => e.preventDefault()}
              className="bg-cfSecondary p-2 rounded-lg w-full lg-xl:w-[25rem] self-center  md:self-end md:m-0 border mt-2"
            >
              <input
                type="text"
                name="search"
                id="vp-check-search-input"
                onChange={()=>{}}
                placeholder="Search for certificate ID, transaction ID"
                className="outline-none border-none p-0 placeholder:text-sm w-full"
                style={{ fontSize: "0.875rem", lineHeight: "1.25rem" }}
              />
            </form> */}
        </div>
      </div>
      <div className="w-full mx-auto bg-white p-8 flex flex-col items-center">
        <div id="checks-form" className="w-full">
          {isLoadingList && <FullScreenLoader />}
          <div
            className={`grid gap-6 ${
              checksList.length === 1
                ? "grid-col-1 w-[24rem]"
                : checksList.length === 2
                ? "grid-col-2 w-[48rem]"
                : "grid-cols-[repeat(auto-fit,minmax(20rem,1fr))]"
            } `}
          >
            {checksList.map(
              ({
                verifiable_presentation_definition_id,
                name,
                description,
                icon,
              }) => (
                <VpCategoryCard
                  key={verifiable_presentation_definition_id}
                  id={`vp-check-card-${verifiable_presentation_definition_id}`}
                  name={name}
                  description={description}
                  icon={`${icon}`}
                  onClick={() =>
                    navigate(
                      `/verifier/vp/qrcode/${category_name}/${verifiable_presentation_definition_id}`
                    )
                  }
                />
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VpVerificationCheck;
